var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"card",staticClass:"border border-gray-dark border-b-2 p-3 rounded"}),_vm._v(" "),(_vm.error)?_c('p',{staticClass:"text-destructive pt-2"},[_vm._v(_vm._s(_vm.error))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }